<div class="content">
  <div class="content-panel">
    <h2 translate>Registres VCI</h2>
    <div class="m-3">

<div class="d-flex justify-content-end mb-2">
  <button class="btn btn-outline-primary d-flex align-items-center gap-2"
          (click)="openColumnModal()">
    <fa-icon icon="columns"></fa-icon>
    <span>Colonnes</span>
    <span class="badge bg-primary text-white ms-2">
      {{ getVisibleColumnCount() }} / {{ columns.length }}
    </span>
  </button>
</div>

<table class="table table-striped" *ngIf="filteredDrevAOCs" aria-label="Liste des stocks VCI">
  <thead>
    <tr>
      <th scope="col" *ngIf="isColumnVisible('millesime')"><input [(ngModel)]="filters.millesime" (input)="applyFilters()" placeholder="Filtrer..." /></th>
      <th scope="col" *ngIf="isColumnVisible('annee')"><input [(ngModel)]="filters.annee" (input)="applyFilters()" placeholder="Filtrer..." /></th>
      <th scope="col" *ngIf="isColumnVisible('produit')"><input [(ngModel)]="filters.produit" (input)="applyFilters()" placeholder="Filtrer..." /></th>
      <th scope="col" *ngIf="isColumnVisible('surface')"></th>
      <th scope="col" *ngIf="isColumnVisible('vciStock')"></th>
      <th scope="col" *ngIf="isColumnVisible('vciRevendique')"></th>
      <th scope="col" *ngIf="isColumnVisible('vciRemplacement')"></th>
      <th scope="col" *ngIf="isColumnVisible('vciSubstitution')"></th>
      <th scope="col" *ngIf="isColumnVisible('vciComplement')"></th>
      <th scope="col" *ngIf="isColumnVisible('vciDetruit')"></th>
      <th scope="col" *ngIf="isColumnVisible('vciNouveau')"></th>
      <th scope="col" *ngIf="isColumnVisible('soldeVCI')"></th>
      <th scope="col"></th>
    </tr>
    <tr>
      <th scope="col" *ngFor="let col of columns" class="liste-col-header"  [hidden]="!col.visible" translate>
        {{ col.label }}
      </th>
      <th scope="col"></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let declaration of filteredDrevAOCs">
      <td *ngIf="isColumnVisible('millesime')">{{ declaration.campagne.annee - 1 }}</td>
      <td *ngIf="isColumnVisible('annee')">{{ declaration.surface > 0 ? declaration.campagne.annee : '' }}</td>
      <td *ngIf="isColumnVisible('produit')">{{ declaration.produit.libelle + ' ' + declaration.drevSaisie.mention  }}</td>
      <td *ngIf="isColumnVisible('surface')">{{ declaration.surface }}</td>
      <td *ngIf="isColumnVisible('vciStock')">{{ declaration.vciPasse | number:'1.2-2' }}</td>
      <td *ngIf="isColumnVisible('vciRevendique')">{{ declaration.drevSaisie.vciRemplacement + declaration.drevSaisie.vciSubstitution + declaration.drevSaisie.vciComplement | number:'1.2-2' }}</td>
      <td *ngIf="isColumnVisible('vciRemplacement')">{{ declaration.drevSaisie.vciRemplacement | number:'1.2-2' }}</td>
      <td *ngIf="isColumnVisible('vciSubstitution')">{{ declaration.drevSaisie.vciSubstitution | number:'1.2-2' }}</td>
      <td *ngIf="isColumnVisible('vciComplement')">{{ declaration.drevSaisie.vciComplement | number:'1.2-2' }}</td>
      <td *ngIf="isColumnVisible('vciDetruit')">{{ declaration.drevSaisie.totalVciDetruit | number:'1.2-2' }}</td>
      <td *ngIf="isColumnVisible('vciNouveau')">{{ declaration.drevSaisie.vciNouveau | number:'1.2-2' }}</td>
      <td *ngIf="isColumnVisible('soldeVCI')">{{ declaration.drevSaisie.vciRemplacement + declaration.drevSaisie.vciNouveau   | number:'1.2-2' }}</td>
      <td><fa-icon  class="clickable-icon icon-with-background" icon="cubes"
                    (click)="utilisationVci(declaration)"
                    title="{{'page.declarations.drev.table.utilisation-vci' | translate}}"></fa-icon></td>
    </tr>
  </tbody>
</table>
<ng-template #columnModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Sélection des colonnes</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>

  <div class="modal-body">
    <div *ngFor="let col of columns" class="form-check">
      <input class="form-check-input" type="checkbox" [checked]="col.visible" (change)="toggleColumnVisibility(col.field)" id="{{col.field}}">
      <label class="form-check-label" [for]="col.field">
        {{ col.label }}
      </label>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.close()">Fermer</button>
  </div>
</ng-template>


<!-- Template aucun historique -->
<ng-template #aucunHistorique>
  <div class="alert alert-warning alert-block" translate>
    <fa-icon icon="exclamation"></fa-icon> page.declarations.suivi-parcellaires-viticoles.aucunHistorique
  </div>
</ng-template>
<!-- Fin template aucun historique -->
    </div>
  </div>
</div>
